import React from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipPill } from 'components/Pill';
import Time from 'components/Time';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LatestInteractionPill(_ref) {
  var latestInteraction = _ref.latestInteraction,
    userContentStatus = _ref.userContentStatus;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var title = undefined;
  if (userContentStatus === 'opened') {
    title = t('state_opened');
  } else if (userContentStatus === 'completed') {
    title = t('state_completed');
  } else if (userContentStatus === 'notstarted') {
    title = t('actions_not_started');
  }
  return /*#__PURE__*/_jsx(TooltipPill, {
    title: title,
    z: "raised",
    children: /*#__PURE__*/_jsx(Time, {
      dateTime: latestInteraction
    })
  });
}